import { useState } from "react";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { Share } from "@remo-co/ui-core/src/icons/Share";
import { IEvent } from "modules/event/types";
import { EventCallToAction } from "../EventCallToAction";
import { useStyles } from "./styles";

interface Props {
  event: IEvent;
}

const EventShareIcon = ({ event }: Props) => {
  const [open, setOpen] = useState(false);
  const [delay, setDelay] = useState<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const classes = useStyles();

  const handleMouseEnter = () => {
    if (delay) {
      clearTimeout(delay);
    }
    setOpen(true);
  };
  const handleMouseLeave = () => setOpen(false);
  const handleDelayedMouseLeave = () => {
    setDelay(setTimeout(() => setOpen(false), 200));
  };

  return (
    <div
      className={classes.sharerContainer}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleDelayedMouseLeave}
    >
      <Button
        variant="tertiary"
        className={classes.sharerButton}
        color="dark"
        size="md"
        data-testid="share-event-button"
      >
        <Share />
      </Button>
      <Card
        elevation={1}
        size="xs"
        className={classes.sharerShareOptions}
        style={{ display: open ? "block" : "none" }}
        onMouseLeave={handleMouseLeave}
      >
        <EventCallToAction
          eventCode={event.code}
          company={event.company}
          eventName={event.name}
          startTime={event.startTime}
        />
      </Card>
    </div>
  );
};

export default EventShareIcon;
